import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {LangService} from "../../services/lang.service";
import { AuthorizationServiceProvider } from '../../auth_profile/services/authorization-service.provider';
import { UserRole } from '../../auth_profile/services/api/authorization.api';
import { LogsService } from '../../utils/services/logs.service';

@Component({
    selector: 'app-book-details-entry-point',
    templateUrl: './book-details-entry-point.component.html',
    styleUrls: ['./book-details-entry-point.component.scss'],
    standalone: false
})
export class BookDetailsEntryPointComponent implements OnInit {

  constructor(private router: Router,
    private langService: LangService,
    private route: ActivatedRoute,
    private authService: AuthorizationServiceProvider,
    private logger: LogsService) {
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      if (params.get('lang')) {
        this.langService.changeLang(params.get('lang'))
      }
      this.authService.getMobile().subscribe(
        mobileApi => mobileApi.getUserRole().subscribe(
          userRole => {
            this.logger.log(`[BookDetailsEntryPoint] mobile userRole=${userRole}`);
            const ebookId = params.get('ebookId');
            if (userRole === UserRole.Student) this.router.navigate([`student/ebooks/${ebookId}`])
            else if (userRole === UserRole.Teacher) this.router.navigate([`teacher/ebooks/${ebookId}`])
            else if (userRole === UserRole.Unaffiliated) this.router.navigate([`unaffiliated/ebooks/${ebookId}`])
            else {
              this.logger.log(`[BookDetailsEntryPoint] unknown role=${userRole} -> /forbidden`);
              this.router.navigate(['forbidden'])
            }
          }
        )
      )
    })
  }

}
